import { race, take } from 'redux-saga/effects';
import { ActionCreator } from '../../../utils/reduxUtils';

export enum AsyncActionResult {
  SUCCESS,
  FAILURE,
  CANCELED,
}

export function* takeAsyncActionResult(asyncAction: {
  success: ActionCreator;
  failure: ActionCreator;
  cancel?: ActionCreator;
}) {
  const { failure, canceled } = yield race({
    success: take(asyncAction.success.type),
    failure: take(asyncAction.failure.type),
    canceled: take(asyncAction.cancel?.type ?? 'NEVER'),
  });

  if (canceled !== undefined) {
    return AsyncActionResult.CANCELED;
  } else if (failure !== undefined) {
    return AsyncActionResult.FAILURE;
  } else {
    return AsyncActionResult.SUCCESS;
  }
}
